import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { login, setToken, getToken } from "@/lib/api";
import { LOGO_MARK } from "@/lib/constants";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getToken()) navigate("/admin");
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await login(email, password);
      setToken(data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[color:var(--bg)] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="grain" aria-hidden="true" />
      <div className="w-full max-w-md">
        <img src={LOGO_MARK} alt="LIS" className="logo-invert h-12 w-auto mb-12" />
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-white/40 mb-4">Admin access</p>
        <h1 className="font-display text-5xl uppercase tracking-tighter leading-[0.85] mb-12">Sign in<span className="text-[color:var(--accent)]">.</span></h1>
        <form onSubmit={submit} className="space-y-8" data-testid="admin-login-form">
          <div>
            <label className="font-mono text-xs tracking-[0.2em] uppercase text-white/40 mb-3 block">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@liinexinfo.org" className="w-full bg-transparent border-b border-white/20 focus:border-white focus:outline-none placeholder-white/30 font-mono py-3 text-white" data-testid="admin-email" />
          </div>
          <div>
            <label className="font-mono text-xs tracking-[0.2em] uppercase text-white/40 mb-3 block">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="w-full bg-transparent border-b border-white/20 focus:border-white focus:outline-none placeholder-white/30 font-mono py-3 text-white" data-testid="admin-password" />
          </div>
          <button type="submit" disabled={busy} className="group w-full inline-flex items-center justify-center gap-3 bg-white text-black px-8 py-5 font-mono text-xs tracking-[0.2em] uppercase hover:bg-[color:var(--accent)] hover:text-white transition-colors disabled:opacity-50" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"} <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </form>
      </div>
    </div>
  );
}
